module.exports = __webpack_public_path__ + "static/media/wit.4db74ec8.JPG";